// src/components/form/HookFormSelect.tsx
import React, { useMemo } from "react";
import { Controller, FieldValues } from "react-hook-form";
import Select, { SingleValue, ActionMeta, GroupBase } from "react-select";
import { createSelectStyles } from "../../styles/selectStyles";
import { IDropdownOption } from "../../interfaces/iDropdown.interface";
import { IFormSelect } from "../../interfaces/iFormSelect.interface";

export function FormSelect<
  TOption extends IDropdownOption,
  TFormValues extends FieldValues
>({
  name,
  control,
  options,
  placeholder,
  disabled,
  defaultZero = true,
}: IFormSelect<TOption, TFormValues>) {
  const byId = useMemo(() => new Map(options.map((o) => [o.id, o])), [options]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Select<TOption, false, GroupBase<TOption>>
          styles={createSelectStyles<TOption>()}
          options={options}
          value={byId.get(field.value as number) ?? null}
          getOptionLabel={(o) => o.name}
          getOptionValue={(o) => o.id.toString()}
          onChange={(val: SingleValue<TOption>, _meta: ActionMeta<TOption>) =>
            field.onChange(val ? val.id : defaultZero ? 0 : null)
          }
          placeholder={placeholder}
          isClearable
          isDisabled={disabled}
        />
      )}
    />
  );
}
